import React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import Hero from '../components/home/Hero';
import About from '../components/home/About';
import Products from '../components/home/Products';
import WhyChooseUs from '../components/home/WhyChooseUs';
import Testimonials from '../components/home/Testimonials';
import Contact from '../components/home/Contact';

function HomePage({ isMobile, setCurrentPage, featuredProducts, cartItemCount, user, onLogout }) {
  return (
    <div className="font-sans">
      <Header 
        isMobile={isMobile} 
        currentPage="home"
        setCurrentPage={setCurrentPage}
        cartItemCount={cartItemCount}
        user={user}
        onLogout={onLogout}
      />
      
      <Hero isMobile={isMobile} setCurrentPage={setCurrentPage} />
      <About isMobile={isMobile} />
      <Products isMobile={isMobile} featuredProducts={featuredProducts} />
      <WhyChooseUs isMobile={isMobile} />
      <Testimonials isMobile={isMobile} />
      <Contact isMobile={isMobile} />
      
      <Footer isMobile={isMobile} setCurrentPage={setCurrentPage} />
    </div>
  );
}

export default HomePage;